// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { operatorId } from './Operator';
import { fermentationScheduledActionId } from './FermentationScheduledAction';
import { steadyStateId } from './SteadyState';
import { z } from 'zod';
export const fermentationTimepointId = (z.number());
export const fermentationTimepoint = z.object({
    id: fermentationTimepointId,
    fermentation_id: fermentationId,
    date_time: z.date(),
    created_at: z.date(),
    created_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    vessel_weight_g: z.string().nullable(),
    notes: z.string().nullable(),
    scheduled_action_id: fermentationScheduledActionId.nullable(),
    steady_state_id: steadyStateId.nullable(),
});
export const fermentationTimepointInitializer = z.object({
    id: fermentationTimepointId.optional(),
    fermentation_id: fermentationId,
    date_time: z.date(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    vessel_weight_g: z.string().optional().nullable(),
    notes: z.string().optional().nullable(),
    scheduled_action_id: fermentationScheduledActionId.optional().nullable(),
    steady_state_id: steadyStateId.optional().nullable(),
});
export const fermentationTimepointMutator = z.object({
    id: fermentationTimepointId.optional(),
    fermentation_id: fermentationId.optional(),
    date_time: z.date().optional(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    vessel_weight_g: z.string().optional().nullable(),
    notes: z.string().optional().nullable(),
    scheduled_action_id: fermentationScheduledActionId.optional().nullable(),
    steady_state_id: steadyStateId.optional().nullable(),
});
//# sourceMappingURL=FermentationTimepoint.js.map